import { mount } from 'svelte';
import SearchCard from './ui/components/SearchCard.svelte';

 


window.addEventListener("DOMContentLoaded", (event) => {
	
	var searchCardEl = document.getElementById('searchcard');
	if( searchCardEl ) {
		mount(SearchCard, {
		    target: searchCardEl,
		});
	}

	// Initialize Google Places Autocomplete on #place_name input if it exists
	/*
	const placeNameInput = document.querySelector("input[name='destination']");
	if (placeNameInput) {
		try {
			const placesAutocomplete = createPlacesAutocomplete(placeNameInput, {
				provider: 'google',
				fields: ['place_id', 'name', 'formatted_address', 'geometry', 'address_components'],
				onPlaceSelected: (place) => {
					console.log('Place selected:', place);
					// Optional: Store place_id in a hidden input for form submission
					const placeIdInput = document.querySelector("input[name='destinationId']");
					if (placeIdInput) {
						placeIdInput.value = 'goo:' + place.id;
					}
				},
				onError: (error) => {
					console.error('Places autocomplete error:', error);
				}
			});
			placesAutocomplete.init();
		} catch (error) {
			console.warn('Could not initialize Google Places Autocomplete:', error.message);
		}
	}
*/
 
/*
	var dest = document.querySelector("input[name='destination']");
	var destId = document.querySelector("input[name='destinationId']");
	var config = {};

	config.uri = '/places/suggestion';
	if (destId) config.valueholder = destId;
	if (dest instanceof HTMLInputElement) {
		new autocomplete(dest, config);
	}
	 

	var checkIn = document.querySelector("input[name='ds']");
	var checkOut = document.querySelector("input[name='de']");
	if (checkIn && checkOut) {
		checkIn.min = formatDateToYYYYMMDD(new Date());
		checkOut.min = formatDateToYYYYMMDD(addDaysToDate(checkIn.min, 1 )); 
		DateRange( { start : checkIn, end : checkOut } );
	}
	*/
});